import React from "react";
import { FaSearch } from "react-icons/fa";

const SearchBar = ({ placeholder = "Buscar...", value, onChange, onKeyDown  }) => {
  return (
    <div style={{ position: "relative", marginBottom: "15px" }}>
      <FaSearch
        style={{
          position: "absolute",
          left: "12px",
          top: "50%",
          transform: "translateY(-50%)",
          color: "#757575",
          fontSize: "16px",
        }}
      />
      <input
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onKeyDown={onKeyDown}
        style={{
          width: "100%",
          padding: "12px 20px 12px 40px",
          borderRadius: "100px",
          border: "1px solid #e0e0e0",
          fontSize: "14px",
          backgroundColor: "#f5f5f5",
          transition: "all 0.3s ease",
        }}
      />
    </div>
  );
};

export default SearchBar;
